import {
    PULS_INFO_REQUEST,
    PULS_INFO_RESULT,
    PULS_INFO_SHOW_MODAL,
    PULS_INFO_HIDE_MODAL,
    CLEAR_REDUX,
    PULS_FILES_REQUEST,
    PULS_FILES_RESULT,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
    loadingFiles: false,
    files: null,
    openModal: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case PULS_INFO_REQUEST:
            return { ...state, loading: true }

        case PULS_INFO_RESULT:
            return { ...state, loading: false, result: action.payload }

        case PULS_INFO_SHOW_MODAL:
            return { ...state, openModal: true };

        case PULS_INFO_HIDE_MODAL:
            return { ...state, openModal: false };

        case PULS_FILES_REQUEST:
            return { ...state, loadingFiles: true }

        case PULS_FILES_RESULT:
            return { ...state, loadingFiles: false, files: action.payload }

        case CLEAR_REDUX:
            return ["", "PULS_INFO_TAB"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};